module.exports = __webpack_public_path__ + "img/emotion.f733137c.png";